module.exports = __webpack_public_path__ + "static/media/th.38996d91.svg";